import React, { useEffect, useState } from 'react';
import { Building2, KeyRound } from 'lucide-react';

const SEL = 'h-9 rounded-lg border border-input bg-background px-3 text-sm text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))]';

// Super-admin-only bar: pick which company's jewellery to view + open user management.
export function TagSuperBar({ companies, companyId, onCompany, onPasswords }) {
  const [value, setValue] = useState(companyId || '');
  useEffect(() => { setValue(companyId || ''); }, [companyId]);
  return (
    <div className="flex min-w-0 max-w-full flex-wrap items-center gap-1.5 sm:gap-2" data-testid="tagws-super-bar">
      <span className="inline-flex items-center gap-1.5 text-sm font-medium text-foreground"><Building2 size={15} className="text-[hsl(var(--ring))]" /> <span className="sr-only">Company</span></span>
      <select value={value} onChange={(e) => { setValue(e.target.value); onCompany(e.target.value); }} className={`${SEL} w-[130px] sm:w-[200px]`} data-testid="tagws-super-company-select">
        <option value="">Personal tags (no company)</option>
        {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
      </select>
      <button onClick={onPasswords} data-testid="tagws-super-view-passwords-button" title="QR tag passwords" className="inline-flex h-9 items-center gap-1.5 rounded-lg border border-border bg-background px-2.5 sm:px-3 text-sm font-medium text-foreground transition-colors duration-150 hover:bg-secondary">
        <KeyRound size={15} /> <span className="hidden xl:inline">QR tag passwords</span>
      </button>
    </div>
  );
}
